import { CreditEligibleStepContent } from "./CreditEligibleStepContent";

export const CreditEligibleStep = () => {
  return <CreditEligibleStepContent />;
};
